/**
 * WARNING: To be deprecated!
 *
 * Deprecation notice: this version of neverGuard will return unexpected values
 * in cases where the input that neverGuard is guarding is dynamic. Consider
 * using neverGuardDefault instead.
 *
 * Use this to cause a compile-time error if all possible types for a value
 * haven't been narrowed away when this is called. I.e. calling this enforces a
 * code path that should never be hit.
 */
export function neverGuard(n) {
    return n;
}
/**
 * Use this to cause a compile-time error if all possible types for value @_n
 * haven't been narrowed away when this is called. I.e. calling this enforces a
 * code path that should never be hit.
 *
 * Typescript still compiles to Javascript, so runtime type exhaustion is not
 * guaranteed. The @defaultValue should be set to handle such cases.
 *
 * @param _n Value to guard
 * @param defaultValue Default value to return
 */
export function neverGuardDefault(_n, defaultValue) {
    return defaultValue;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibmV2ZXJHdWFyZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9uZXZlckd1YXJkLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7O0dBVUc7QUFDSCxNQUFNLFVBQVUsVUFBVSxDQUFDLENBQVE7SUFDakMsT0FBTyxDQUFDLENBQUM7QUFDWCxDQUFDO0FBRUQ7Ozs7Ozs7Ozs7R0FVRztBQUNILE1BQU0sVUFBVSxpQkFBaUIsQ0FBSSxFQUFTLEVBQUUsWUFBZTtJQUM3RCxPQUFPLFlBQVksQ0FBQztBQUN0QixDQUFDIn0=